import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  title: {
    fontWeight: 700,
  },
  text: {
    color: '#1E1E1E',
    width: 'initial',
  },
}));
